import { ThemeColorVariable } from '@caspeco/casper-ui-library.base-ui.theme';
const uncheckedHoverStyleSelector = 'label:not([data-checked]):not([data-disabled]):hover';
const checkedHoverStyleSelector = 'label[data-checked]:not([data-disabled]):hover';
const disabledUncheckedHoverStyleSelector = 'label[data-disabled]:not([data-checked]):hover';
const disabledCheckedHoverStyleSelector = 'label[data-disabled][data-checked]:hover';
export const hoverStyles = {
    // Target only device that supports hover (excludes thouch screen devices):
    '@media(hover: hover)': {
        // General hover styles for entire switch:
        [uncheckedHoverStyleSelector]: {
            '.chakra-switch__track': {
                borderColor: ThemeColorVariable.OnSurface,
            },
            '.chakra-switch__thumb': {
                bg: ThemeColorVariable.OnSurface,
            },
        },
        [checkedHoverStyleSelector]: {
            '.chakra-switch__track': {
                bg: ThemeColorVariable.AccentHover,
                borderColor: ThemeColorVariable.AccentHover,
            },
            '.chakra-switch__thumb': {
                bg: ThemeColorVariable.OnAccent,
            },
        },
        [disabledUncheckedHoverStyleSelector]: {
            '.chakra-switch__track': {
                bg: ThemeColorVariable.Surface,
                borderColor: ThemeColorVariable.OnSurfaceSubdued,
            },
            '.chakra-switch__thumb': {
                bg: ThemeColorVariable.OnSurfaceSubdued,
            },
        },
        [disabledCheckedHoverStyleSelector]: {
            '.chakra-switch__track': {
                bg: ThemeColorVariable.Accent,
                borderColor: ThemeColorVariable.Accent,
            },
            '.chakra-switch__thumb': {
                bg: ThemeColorVariable.OnAccent,
            },
        },
    },
};
//# sourceMappingURL=switch.hoverstyles.js.map